import { INBOARD, OUTBOARD, YACHT, MODIFIED_V, SEMI_V, TRI_HULL, V } from 'constants/boatApplication';
import { _initBoatSystems } from './BaseBoat';

const initState = {
  id: 'new',
  boatType: YACHT,
  status: 'DRAFT',
  engineType: null,
  boatSpecifications: {},
  boatSystems: [],
  floatationCapacity: {},
  additionalFiles: [],
};

export default class Yacht {
  constructor(boat = initState) {
    this.id = boat.id || initState.id;
    this.boatType = YACHT;
    this.status = boat.status || initState.status;
    this.engineType = boat.engineType;
    this.plateType = boat.plateType;
    this.boatSpecifications = _initBoatSpecifications(boat.boatSpecifications || boat);
    this.boatSystems = _initBoatSystems(boat.boatSystems);
    this.cubicCapacity = {};
    this.personPowerCapacity = {};
    this.powerCapacity = null;
    this.floatationCapacity = {};
    this.additionalFiles = boat.additionalFiles ? [...boat.additionalFiles] : initState.additionalFiles;
    this.specificationsRequiredFieldsList = getSpecificationsRequiredFieldsList.call(this);
    this.isFloatationTestReportRequired = boat.boatSpecifications ? boat.boatSpecifications.lengthFeet < 20 : boat.lengthFeet < 20;
    this.bottomContourList =
      [
        {name: 'Modified V', value: MODIFIED_V},
        {name: 'Semi V', value: SEMI_V},
        {name: 'Tri Hull', value: TRI_HULL},
        {name: 'V', value: V},
      ];
    this.engineTypesList =
      [
        INBOARD,
        OUTBOARD
      ];
    this.engineSubTypesList =
      [
        {name: 'Up to 6 HP.', value: 'SUB_TYPE_1'},
        {name: 'Over 6 HP. and up to 20 HP.', value: 'SUB_TYPE_2'},
        {name: 'Over 20 HP. and up to 100 HP.', value: 'SUB_TYPE_3'},
        {name: 'Over 100 HP.', value: 'SUB_TYPE_4'},
      ];
  }
}

function getSpecificationsRequiredFieldsList() {
  return [
    'name',
    'year',
    'cityAndStateForCapacityTag',
    'lengthFeet',
  ];
}

function _initBoatSpecifications(boat) {
  return {
    name: boat.name || '',
    year: boat.year || '',
    cityAndStateForCapacityTag: boat.cityAndStateForCapacityTag || '',
    lengthFeet: boat.lengthFeet === undefined ? '' : boat.lengthFeet,
    lengthInches: boat.lengthInches === undefined ? '' : boat.lengthInches,
  };
}



// WEBPACK FOOTER //
// ./src/app/store/models/Yacht.js